export default "__VITE_ASSET__C2gO5InS__"